// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import { NextTravelApi } from "../api/next-travel.api";

export default class NextTravelStore {
  @observable nextTravel: any = [];
  @observable cardProfileId: number = 0;
  @observable bonusesResident: number = 0;

  @action calculateNextTravel = async (tim: string) => {
    const cacUserProfile = await NextTravelApi.getCacUserProfile(tim);
    const walletInfo = await NextTravelApi.getMyWalletInfo();
    let array = [];
    for (let i = 0; i < 5; i++) {
      const res = await NextTravelApi.getNextTravel(
        i,
        walletInfo.points,
        cacUserProfile.profileId
      );
      array.push({ hops: i, price: Math.round((res / 100) * 100) / 100 });
    }
    this.nextTravel = array;
    this.cardProfileId = cacUserProfile.profileId;
  };

  @action getBonusesResident = async (profileId: number) => {
    const res = await NextTravelApi.getBonusesResident(profileId);
    this.bonusesResident = res.pointCost;
  };
}
